// import DataTable from "src/components/tables/presentation";

import { Badge, Button, Label } from 'flowbite-react';
import { useState } from 'react';
import DataTable from 'src/components/tables';
import AddEditRole from './add-edit-roles';
import CustomButton from 'src/components/common/custom-buttom';
import { AccessRight } from 'src/routes/PermissionEnum';

const Roles = () => {
  const [initialData, setInitialData] = useState<any>();

  const columns = [
    {
      header: 'name',
      accessor: 'Name',
      cell: (row: any) => (
        <Label
          onClick={() => {
            setInitialData(row);
          }}
          className="text-blue-600 cursor-pointer"
          value={row?.name}
        />
      ),
    },
    { header: 'Description', accessor: 'description' },
    {
      header: 'Status',
      accessor: 'status',
      cell: (row) => (
        <Badge
          className={`${
            row.status == 'new'
              ? 'bg-blue-400'
              : row.status == 'active'
              ? 'bg-green-400'
              : 'bg-red-400'
          } rounded-lg`}
        >
          {row.status}
        </Badge>
      ),
    },
  ];

  return (
    <>
      <AddEditRole handleClose={setInitialData} initialData={initialData} />
      <DataTable
        heading="Roles"
        columns={columns}
        additionalUI={
          <CustomButton accessRight={AccessRight.ISEDIT}  onClick={() => setInitialData(true)} size="xs">
            Add Roles
          </CustomButton>
        }
        config={{ url: 'role', key: ['role'] }}
      />
    </>
  );
};

export default Roles;
